import React, { createContext, useContext, useState, useEffect } from 'react';
import SponsorService from '../services/sponsorService';

const SponsorContext = createContext(null);

export const SponsorProvider = ({ children }) => {
    const [sponsorData, setSponsorData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        SponsorService.getBrandPartnership()
            .then((res) => {
                if (res?.status === 'success' && res?.data) {
                    setSponsorData(res.data);
                } else {
                    setSponsorData({ enabled: false });
                }
            })
            .catch(() => {
                // If API fails, silently disable partnerships
                setSponsorData({ enabled: false });
            })
            .finally(() => setLoading(false));
    }, []);

    const authBg = sponsorData?.auth_background_image_url || null;

    return (
        <SponsorContext.Provider value={{ sponsorData, loading, authBg }}>
            {children}
        </SponsorContext.Provider>
    );
};

export const useSponsor = () => useContext(SponsorContext);
